/** Sand is weighed in tonnes (tone) or kilograms — not cubic metres. */
export const SAND_UNIT_OPTIONS = [
  { value: 'tonne', label: 'Tonnes (tone)' },
  { value: 'kg', label: 'Kilograms (kg)' },
];

export function normalizeSandUnit(unit) {
  return String(unit || '').toLowerCase() === 'kg' ? 'kg' : 'tonne';
}

export function sandUnitShort(unit) {
  return normalizeSandUnit(unit) === 'kg' ? 'kg' : 'tonne';
}

export function sandUnitLabel(unit) {
  return normalizeSandUnit(unit) === 'kg' ? 'Kilograms (kg)' : 'Tonnes (tone)';
}

export function formatSandAmount(value, unit) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const u = sandUnitShort(unit);
  return `${n.toLocaleString('en-TZ', { maximumFractionDigits: 3 })} ${u}`;
}
